export const BackIcon = (props) => {
  const { className, fill = "#fff" } = props;
  return (
    <svg
      alt="Back"
      className={className}
      width="16"
      height="14"
      viewBox="0 0 16 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70711 0.292893C8.09763 0.683418 8.09763 1.31658 7.70711 1.70711L3.41421 6H15C15.5523 6 16 6.44771 16 7C16 7.55228 15.5523 8 15 8H3.41421L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C0.105357 7.51957 0 7.26522 0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z"
        fill={fill}
      />
    </svg>
  );
};

export const NextIcon = (props) => {
  const { className = "", fill = "#fff" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      className={className}
    >
      <path
        d="M1.16667 7.00008H12.8333M12.8333 7.00008L7 1.16675M12.8333 7.00008L7 12.8334"
        stroke={fill}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BehindSwiftyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="110"
      viewBox="0 0 110 110"
      fill="none"
    >
      <rect
        x="13.2732"
        y="13.2732"
        width="83.4533"
        height="83.4533"
        rx="41.7266"
        fill="url(#paint0_linear_363_880)"
      />
      <rect
        x="13.2732"
        y="13.2732"
        width="83.4533"
        height="83.4533"
        rx="41.7266"
        stroke="url(#paint1_linear_363_880)"
        strokeWidth="1.40385"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8245 52.6171C39.7462 55.6669 40.1815 59.4073 44.3096 60.1072C47.3032 60.6103 52.0891 59.5198 58.6705 56.8293C59.055 56.6731 59.4427 56.5106 59.8399 56.345C52.9566 61.7696 46.5691 64.3632 40.6805 64.1258C35.2177 63.8976 29.6055 61.6197 30.0218 55.3169C31.0197 40.2335 57.5201 30.0748 70.8672 29.9998C67.0537 31.2934 63.3388 32.8527 59.7509 34.6651C62.5316 34.3182 65.344 34.287 68.1342 34.5651C64.165 35.7056 60.3198 37.2274 56.6525 39.1054C59.4268 38.4399 62.2678 38.068 65.1216 37.993C57.6154 40.3085 46.3657 45.9675 41.8245 52.6171ZM68.1692 57.3793C70.2411 54.3295 69.8121 50.5891 65.6841 49.8891C62.6206 49.3704 57.6822 50.5235 50.8688 53.3483L50.3857 53.5514L50.1601 53.6451L50.3666 53.4858C50.5065 53.3764 50.6495 53.267 50.7893 53.1608C50.9133 53.0671 51.0372 52.9733 51.1548 52.8827C51.3836 52.7046 51.6124 52.5359 51.8412 52.3702C51.8603 52.3577 51.8793 52.3421 51.8984 52.3296C58.1207 47.7986 63.9299 45.6457 69.3195 45.8706C74.7823 46.0988 80.3945 48.3767 79.9782 54.6795C78.9803 69.7629 52.4799 79.9216 39.136 79.9998C42.9495 78.7061 46.6644 77.1468 50.2522 75.3344C47.4684 75.6813 44.6528 75.7125 41.8594 75.4344C45.8286 74.2907 49.6739 72.7721 53.3411 70.8941C50.5668 71.5597 47.7258 71.9315 44.8721 72.0034C52.3783 69.6879 63.6248 64.0382 68.1692 57.3793Z"
        fill="white"
      />
      <circle
        opacity="0.8"
        cx="55.0001"
        cy="54.9999"
        r="45.1035"
        stroke="url(#paint2_linear_363_880)"
        strokeWidth="0.935897"
      />
      <circle
        opacity="0.7"
        cx="54.9994"
        cy="55.0002"
        r="48.2463"
        stroke="url(#paint3_linear_363_880)"
        strokeWidth="0.935897"
      />
      <path
        opacity="0.6"
        d="M106.389 55C106.389 83.3814 83.3812 106.389 54.9997 106.389C26.6183 106.389 3.61053 83.3814 3.61053 55C3.61053 26.6185 26.6183 3.61077 54.9997 3.61077C83.3812 3.61077 106.389 26.6185 106.389 55Z"
        stroke="url(#paint4_linear_363_880)"
        strokeWidth="0.935897"
      />
      <circle
        opacity="0.5"
        cx="55"
        cy="55"
        r="54.5321"
        stroke="url(#paint5_linear_363_880)"
        strokeWidth="0.935897"
      />
      <defs>
        <linearGradient
          id="paint0_linear_363_880"
          x1="12.2191"
          y1="12.9289"
          x2="95.5727"
          y2="97.6986"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_363_880"
          x1="12.2191"
          y1="12.9289"
          x2="95.5727"
          y2="97.6986"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_363_880"
          x1="9.05042"
          y1="9.81261"
          x2="98.5784"
          y2="100.861"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_363_880"
          x1="5.88078"
          y1="6.69652"
          x2="101.583"
          y2="104.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_363_880"
          x1="2.71211"
          y1="3.57995"
          x2="104.589"
          y2="107.187"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_363_880"
          x1="-0.456553"
          y1="0.463619"
          x2="107.594"
          y2="110.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="33"
      viewBox="0 0 34 33"
      fill="none"
    >
      <path
        d="M17.25 0C20.0625 7.65461 26.0954 13.6875 33.75 16.5C26.0954 19.3125 20.0625 25.3454 17.25 33C14.4375 25.3454 8.40461 19.3125 0.75 16.5C8.40461 13.6875 14.4375 7.65461 17.25 0Z"
        fill="url(#paint0_linear_419_203)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_419_203"
          x1="0.613034"
          y1="0.139086"
          x2="33.0283"
          y2="33.1051"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SwiftyIcon = (props) => {
  const { className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="122"
      height="36"
      viewBox="0 0 122 36"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34814 16.2845C6.88083 18.4803 7.18822 21.1734 10.1027 21.6774C12.2161 22.0396 15.595 21.2544 20.2415 19.3173C20.5129 19.2048 20.7867 19.0878 21.0671 18.9686C16.2075 22.8743 11.6978 24.7417 7.54045 24.5707C3.6837 24.4065 -0.278505 22.7663 0.0154068 18.2284C0.719897 7.36829 19.4293 0.0539966 28.8524 0C26.1601 0.931442 23.5373 2.05412 21.0043 3.35904C22.9675 3.1093 24.953 3.0868 26.9229 3.28704C24.1207 4.10824 21.4059 5.20393 18.8168 6.55609C20.7755 6.07687 22.7812 5.80913 24.796 5.75514C19.4966 7.42228 11.5542 11.4968 8.34814 16.2845ZM26.9476 19.7133C28.4104 17.5174 28.1076 14.8243 25.1931 14.3204C23.0303 13.9469 19.5437 14.7771 14.7334 16.8109L14.3924 16.9572L14.2331 17.0247L14.3789 16.9099C14.4777 16.8312 14.5786 16.7525 14.6774 16.676C14.7649 16.6085 14.8523 16.541 14.9354 16.4757C15.0969 16.3475 15.2584 16.226 15.42 16.1067C15.4334 16.0977 15.4469 16.0865 15.4604 16.0775C19.8533 12.8152 23.9546 11.265 27.7598 11.427C31.6165 11.5913 35.5787 13.2314 35.2848 17.7694C34.5803 28.6295 15.8709 35.9438 6.45007 36C9.14239 35.0686 11.7652 33.9459 14.2982 32.641C12.3328 32.8907 10.3449 32.9132 8.37282 32.713C11.1751 31.8895 13.8898 30.7961 16.479 29.4439C14.5203 29.9231 12.5145 30.1909 10.4998 30.2426C15.7992 28.5755 23.7392 24.5077 26.9476 19.7133Z"
        fill="url(#paint0_linear_388_286)"
      />
      <path
        d="M54.4472 20.7097C54.4472 19.9808 54.1891 19.4138 53.6709 19.0066C53.1616 18.5994 52.2619 18.1786 50.9718 17.7444C49.6818 17.3102 48.6272 16.8895 47.8083 16.4823C45.1429 15.1683 43.8103 13.3617 43.8103 11.0646C43.8103 9.91941 44.1401 8.91373 44.7997 8.04303C45.4683 7.16333 46.4106 6.48388 47.6244 6.00016C48.8382 5.50744 50.2045 5.26221 51.7212 5.26221C53.1997 5.26221 54.5234 5.52769 55.6901 6.05641C56.868 6.58512 57.7812 7.34333 58.4296 8.32651C59.0802 9.3007 59.4033 10.4166 59.4033 11.6743H54.4584C54.4584 10.8329 54.2004 10.1804 53.6821 9.71693C53.1728 9.25345 52.4818 9.02172 51.6068 9.02172C50.7205 9.02172 50.0205 9.21971 49.5023 9.61793C48.993 10.0049 48.7394 10.5021 48.7394 11.1073C48.7394 11.6361 49.0221 12.1198 49.5875 12.554C50.1529 12.9792 51.1468 13.4247 52.567 13.8882C53.9895 14.3426 55.1561 14.8331 56.0693 15.3641C58.2927 16.651 59.4033 18.4239 59.4033 20.6827C59.4033 22.4894 58.7257 23.9068 57.3683 24.9372C56.0109 25.9677 54.1532 26.4829 51.7885 26.4829C50.1215 26.4829 48.6093 26.1859 47.2542 25.5897C45.908 24.9845 44.8917 24.161 44.2029 23.1216C43.5253 22.0709 43.1865 20.8672 43.1865 19.5038H48.1583C48.1583 20.6107 48.4411 21.4274 49.0064 21.9584C49.5808 22.4781 50.5074 22.7391 51.7885 22.7391C52.6074 22.7391 53.2536 22.5636 53.7225 22.2149C54.2071 21.8549 54.4472 21.3532 54.4472 20.7097Z"
        fill="#232A38"
      />
      <path
        d="M74.3508 19.9025L75.8899 10.8535H80.4534L76.8524 26.2021H72.8274L70.2988 17.0946L67.7569 26.2021H63.7318L60.1309 10.8535H64.6943L66.2065 20.1162L68.6364 10.8535H71.9569L74.3508 19.9025Z"
        fill="#232A38"
      />
      <path
        d="M86.6118 26.1998H81.8374V10.8512H86.6118V26.1998ZM81.5547 6.89374C81.5547 6.21204 81.7992 5.65407 82.2906 5.21985C82.7797 4.78562 83.4169 4.56738 84.1977 4.56738C84.9784 4.56738 85.6156 4.78562 86.1047 5.21985C86.5938 5.65407 86.8384 6.21204 86.8384 6.89374C86.8384 7.57545 86.5938 8.13341 86.1047 8.56763C85.6156 9.00186 84.9784 9.2201 84.1977 9.2201C83.4169 9.2201 82.7797 9.00186 82.2906 8.56763C81.8015 8.13341 81.5547 7.57545 81.5547 6.89374Z"
        fill="#232A38"
      />
      <path
        d="M90.0314 26.1996V14.1718H87.8125V10.8533H90.0314V9.63385C90.0314 7.88346 90.5452 6.52679 91.5705 5.56385C92.5959 4.60091 94.0385 4.11719 95.894 4.11719C96.5715 4.11719 97.3164 4.21618 98.1263 4.41417L98.1398 7.93295C97.8481 7.84746 97.4577 7.80471 96.9686 7.80471C95.5282 7.80471 94.808 8.42792 94.808 9.67659V10.8533H97.7875V14.1718H94.808V26.1996H90.0314Z"
        fill="#232A38"
      />
      <path
        d="M104.425 7.03545V10.8512H106.941V14.1698H104.425V21.1916C104.425 21.7675 104.529 22.1703 104.735 22.3975C104.941 22.6247 105.352 22.7372 105.965 22.7372C106.436 22.7372 106.831 22.708 107.151 22.6517V26.0693C106.294 26.3437 105.399 26.481 104.468 26.481C102.83 26.481 101.619 26.094 100.838 25.3178C100.057 24.5416 99.6645 23.3649 99.6645 21.7855V14.1675H97.7148V10.849H99.6645V7.0332H104.425V7.03545Z"
        fill="#232A38"
      />
      <path
        d="M114.358 19.504L116.9 10.8511H122L115.77 28.7667L115.503 29.4192C114.616 31.4058 113.055 32.398 110.814 32.398C110.192 32.398 109.537 32.3035 108.85 32.1145V28.697H109.472C110.14 28.697 110.65 28.598 110.998 28.4C111.354 28.211 111.619 27.8668 111.79 27.365L112.171 26.3436L106.86 10.8533H111.947L114.358 19.504Z"
        fill="#232A38"
      />
      <defs>
        <linearGradient
          id="paint0_linear_388_286"
          x1="-0.146513"
          y1="0.15173"
          x2="35.2205"
          y2="35.4204"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SwiftyPlatformIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" fill="#E4F4FE" />
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" stroke="#4086FA" />
      <g clipPath="url(#clip0_260_480)">
        <path
          d="M33.5057 48.8522C32.7306 50.5469 30.1439 54.5001 22.8753 54.5001C22.5106 54.5001 22.1608 54.3552 21.903 54.0973C21.6451 53.8395 21.5003 53.4897 21.5003 53.1251C21.5003 45.8565 25.4534 43.2697 27.1481 42.4946C27.3124 42.4197 27.4899 42.3778 27.6703 42.3715C27.8508 42.3651 28.0308 42.3944 28.2 42.4576C28.3691 42.5208 28.5242 42.6167 28.6563 42.7398C28.7884 42.863 28.895 43.0109 28.9699 43.1752C29.0449 43.3395 29.0867 43.517 29.0931 43.6975C29.0994 43.878 29.0702 44.0579 29.007 44.2271C28.9438 44.3963 28.8479 44.5514 28.7247 44.6835C28.6016 44.8156 28.4536 44.9222 28.2893 44.9971C27.1842 45.5007 24.7453 47.1215 24.3156 51.6847C28.8789 51.2551 30.5031 48.8162 31.0032 47.711C31.0782 47.5467 31.1847 47.3987 31.3168 47.2756C31.449 47.1525 31.604 47.0566 31.7732 46.9934C31.9424 46.9302 32.1223 46.9009 32.3028 46.9073C32.4833 46.9136 32.6608 46.9554 32.8251 47.0304C32.9894 47.1053 33.1374 47.2119 33.2605 47.344C33.3836 47.4761 33.4795 47.6312 33.5427 47.8003C33.6059 47.9695 33.6352 48.1495 33.6289 48.33C33.6225 48.5105 33.5807 48.6879 33.5057 48.8522ZM54.4745 24.1022C54.4337 23.4318 54.149 22.7995 53.6741 22.3245C53.1991 21.8496 52.5668 21.5649 51.8964 21.5241C49.7342 21.3952 44.2084 21.5929 39.6245 26.1768L31.1253 34.6829C30.9976 34.8107 30.846 34.9122 30.6792 34.9815C30.5123 35.0508 30.3335 35.0865 30.1528 35.0867C29.7879 35.087 29.4379 34.9424 29.1796 34.6846C28.9214 34.4268 28.7761 34.077 28.7758 33.7121C28.7755 33.3473 28.9201 32.9972 29.1779 32.739L33.7429 28.1722C33.8385 28.0761 33.9035 27.9539 33.9298 27.8209C33.9561 27.6879 33.9425 27.5501 33.8907 27.4249C33.8389 27.2996 33.7512 27.1924 33.6387 27.1168C33.5261 27.0413 33.3938 27.0006 33.2582 27.0001H28.7792C28.4169 26.9981 28.0579 27.0683 27.723 27.2064C27.3881 27.3445 27.084 27.5478 26.8284 27.8044L20.9331 33.7032C20.5715 34.0645 20.3178 34.5194 20.2005 35.0169C20.0831 35.5143 20.1067 36.0347 20.2686 36.5195C20.4305 37.0043 20.7243 37.4344 21.117 37.7615C21.5098 38.0886 21.9859 38.2998 22.492 38.3713L29.104 39.2943L36.7026 46.8929L37.6256 53.5083C37.6965 54.0145 37.9077 54.4906 38.2351 54.8831C38.5625 55.2755 38.9932 55.5685 39.4784 55.729C39.761 55.8234 40.057 55.8715 40.3549 55.8716C40.7157 55.8723 41.0731 55.8016 41.4064 55.6635C41.7398 55.5255 42.0425 55.3228 42.2971 55.0672L48.1959 49.1719C48.4518 48.9157 48.6546 48.6115 48.7926 48.2768C48.9307 47.942 49.0012 47.5833 49.0003 47.2212V42.7421C49 42.6062 48.9595 42.4734 48.8839 42.3605C48.8082 42.2476 48.7008 42.1597 48.5751 42.1078C48.4495 42.0559 48.3113 42.0425 48.1781 42.0691C48.0448 42.0957 47.9224 42.1613 47.8264 42.2574L43.2596 46.8224C43.1261 46.9561 42.9664 47.0608 42.7905 47.1301C42.6147 47.1993 42.4264 47.2315 42.2376 47.2247C42.0487 47.218 41.8633 47.1723 41.6928 47.0907C41.5224 47.009 41.3706 46.8931 41.247 46.7502C41.0214 46.4774 40.9068 46.1297 40.9259 45.7762C40.945 45.4227 41.0965 45.0893 41.3501 44.8424L49.8184 36.3741C54.4057 31.7885 54.6034 26.2627 54.4745 24.0988V24.1022Z"
          fill="#4086FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_260_480">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(16 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SwiftySportsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" fill="#E4F4FE" />
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" stroke="#4086FA" />
      <path
        d="M21.4258 52.4156C22.8214 53.6968 24.5657 54.5351 26.4379 54.8246C26.6421 53.7972 26.6044 52.7364 26.3276 51.7261C26.0508 50.7159 25.5425 49.784 24.8431 49.0042L21.4258 52.4156ZM39.073 50.9781C38.5225 50.9781 37.9844 51.1414 37.5267 51.4472C37.069 51.7531 36.7123 52.1878 36.5017 52.6963C36.291 53.2049 36.2359 53.7645 36.3433 54.3044C36.4507 54.8443 36.7158 55.3402 37.1051 55.7294C37.4943 56.1187 37.9902 56.3837 38.5301 56.4911C39.07 56.5985 39.6296 56.5434 40.1382 56.3327C40.6468 56.1221 41.0814 55.7653 41.3873 55.3076C41.6931 54.8499 41.8563 54.3118 41.8563 53.7614C41.8555 53.0234 41.562 52.316 41.0402 51.7942C40.5184 51.2724 39.8109 50.9789 39.073 50.9781ZM37.531 44.6543C37.0668 44.7402 36.5957 44.7836 36.1236 44.7838C34.243 44.7839 32.4294 44.0853 31.0349 42.8235L28.5134 45.3406L35.0205 51.8363C36.656 50.0693 37.5616 47.7485 37.5553 45.3408C37.5553 45.1106 37.5472 44.8818 37.531 44.6543Z"
        fill="#4086FA"
      />
      <path
        d="M25.4248 48.4244C26.2039 49.2959 26.7739 50.3338 27.0912 51.4589C27.4086 52.584 27.465 53.7668 27.2562 54.917C28.5608 55.0105 29.8708 54.8369 31.106 54.4068C32.3412 53.9767 33.4757 53.2992 34.4401 52.4156L27.933 45.9202L25.4248 48.4244ZM45.2177 55.1833C45.1934 55.2 45.1728 55.2212 45.1568 55.2458C45.1408 55.2705 45.1298 55.298 45.1245 55.3269C45.1191 55.3558 45.1196 55.3854 45.1257 55.4141C45.1318 55.4428 45.1436 55.4701 45.1602 55.4942C45.3708 55.7982 45.6933 56.0063 46.0569 56.0731C46.4206 56.1399 46.7959 56.06 47.1008 55.8508L48.3952 54.9608C48.5712 54.8392 48.7169 54.6787 48.821 54.4917L47.3682 53.7048L45.2177 55.1833ZM46.5581 53.2661L44.2105 51.9945L45.561 53.9517L46.5581 53.2661ZM53.1081 42.8343L43.7277 43.44L43.3037 45.4169L52.6827 46.1055C52.9327 46.1231 53.1819 46.0603 53.3938 45.9263L55.8316 44.3724L54.1676 43.1401C53.8626 42.9142 53.4865 42.8057 53.1081 42.8343ZM54.9643 24.073C54.5598 23.3023 53.9484 22.6597 53.1989 22.2172L52.5969 23.5207L54.7598 24.5157L54.9643 24.073ZM51.582 51.3745L42.7155 48.1597L42.3135 50.0341L50.5535 54.4972C50.9096 54.6907 51.3265 54.7396 51.7177 54.6336L53.751 54.0864L52.1356 51.7969C51.9988 51.6026 51.8056 51.4551 51.582 51.3745ZM52.7658 46.9285C52.7182 46.9285 52.6705 46.9268 52.623 46.9234L43.1304 46.2261L42.8894 47.3499L51.8621 50.6031C51.9494 50.6351 52.0344 50.6731 52.1164 50.7168L55.5012 49.2866L53.0634 46.9053C52.9649 46.9205 52.8655 46.9283 52.7658 46.9285ZM40.3334 49.5052L41.7006 43.1085L42.9023 43.3653L41.5352 49.7621L40.3334 49.5052ZM44.2134 42.5866L45.8433 39.0566C45.5921 38.9756 45.346 38.8797 45.1062 38.7695C44.8663 38.6586 44.6331 38.5339 44.4076 38.3961L42.5364 42.4484L43.4223 42.6377L44.2134 42.5866ZM39.7613 42.1929L39.6519 42.0342C39.2347 41.4305 39.0558 40.6936 39.1499 39.9658C39.218 39.4388 39.0885 38.9051 38.7863 38.468L27.9656 22.7881C27.6263 22.2987 27.1071 21.9635 26.5214 21.8559C25.9357 21.7483 25.3312 21.877 24.8402 22.2139C24.5974 22.3806 24.3899 22.5936 24.2295 22.8406C24.0692 23.0876 23.9591 23.3639 23.9057 23.6535C23.8522 23.9431 23.8564 24.2404 23.918 24.5284C23.9796 24.8164 24.0974 25.0894 24.2647 25.3318L31.2537 35.4589C32.9484 36.0253 34.4693 37.0172 35.6708 38.3397C36.8723 39.6622 37.7142 41.271 38.1158 43.0121C38.5738 42.586 39.1453 42.3015 39.7613 42.1929ZM25.6931 24.6107C25.6483 24.6406 25.598 24.6613 25.5452 24.6717C25.4923 24.6821 25.438 24.682 25.3852 24.6714C25.3323 24.6608 25.2821 24.6399 25.2374 24.6099C25.1927 24.5799 25.1543 24.5414 25.1244 24.4966L25.0311 24.3557C25.0012 24.3109 24.9805 24.2606 24.9701 24.2078C24.9597 24.1549 24.9597 24.1006 24.9703 24.0478C24.9809 23.9949 25.0018 23.9447 25.0318 23.9C25.0618 23.8553 25.1003 23.8169 25.1452 23.787C25.19 23.7572 25.2403 23.7364 25.2931 23.726C25.346 23.7156 25.4004 23.7157 25.4532 23.7263C25.506 23.7369 25.5562 23.7578 25.6009 23.7878C25.6457 23.8178 25.6841 23.8563 25.7139 23.9011L25.8076 24.042C25.8374 24.0868 25.8581 24.1371 25.8685 24.19C25.8789 24.2428 25.8788 24.2972 25.8682 24.35C25.8575 24.4029 25.8366 24.4531 25.8066 24.4978C25.7766 24.5425 25.738 24.5809 25.6931 24.6107ZM30.0326 31.1299C29.9878 31.1597 29.9375 31.1805 29.8846 31.1909C29.8318 31.2013 29.7774 31.2012 29.7246 31.1906C29.6718 31.18 29.6216 31.1591 29.5769 31.1291C29.5321 31.0991 29.4937 31.0606 29.4639 31.0158L25.9558 25.7457C25.9251 25.7009 25.9035 25.6504 25.8925 25.5972C25.8814 25.544 25.881 25.4891 25.8914 25.4358C25.9017 25.3824 25.9225 25.3316 25.9526 25.2864C25.9828 25.2412 26.0216 25.2024 26.0668 25.1723C26.112 25.1421 26.1628 25.1213 26.2162 25.111C26.2695 25.1007 26.3244 25.1011 26.3776 25.1121C26.4308 25.1232 26.4813 25.1447 26.5261 25.1755C26.5709 25.2062 26.6092 25.2456 26.6386 25.2912L30.1468 30.5612C30.2071 30.6518 30.2289 30.7625 30.2075 30.8692C30.1861 30.9758 30.1233 31.0696 30.0328 31.1299H30.0326ZM39.5212 49.3686L40.8964 42.9576C39.6961 42.834 38.5775 43.3529 38.3124 44.1913C38.3543 44.573 38.3754 44.9567 38.3756 45.3407C38.3769 46.4483 38.2018 47.5489 37.8569 48.6014C38.3146 49.208 39.0702 49.3239 39.5212 49.3686ZM49.1624 29.0023L46.9996 28.0072L46.1708 29.8023L48.3335 30.7974L49.1624 29.0023ZM24.8439 47.8448L27.3526 45.3407L20.8453 38.8449C19.2099 40.612 18.3042 42.9328 18.3106 45.3405C18.3106 45.5673 18.3185 45.7928 18.3343 46.0169C19.4869 45.8073 20.6721 45.8629 21.8 46.1797C22.9279 46.4964 23.9689 47.0658 24.8439 47.8448Z"
        fill="#4086FA"
      />
      <path
        d="M18.4258 46.8348C18.7165 48.7055 19.5589 50.447 20.845 51.8362L24.2627 48.4246C23.4794 47.7256 22.5444 47.2182 21.5315 46.9423C20.5185 46.6664 19.4554 46.6296 18.4258 46.8348ZM30.4548 42.2437C29.6693 41.3789 29.0949 40.3439 28.7767 39.2198C28.4585 38.0957 28.4051 36.9132 28.6206 35.765C28.3917 35.7486 28.1624 35.7404 27.9328 35.7404C25.5238 35.7362 23.2013 36.6376 21.4257 38.2657L27.9328 44.761L30.4548 42.2437Z"
        fill="#4086FA"
      />
      <path
        d="M34.4395 38.2659C33.0465 36.9871 31.3062 36.1495 29.4378 35.8585C29.2366 36.8838 29.2763 37.9417 29.5535 38.9491C29.8308 39.9565 30.3381 40.8857 31.0356 41.6637L34.4395 38.2659ZM37.4378 43.8362C37.1456 41.9692 36.304 40.2316 35.0203 38.8449L31.616 42.2429C32.3974 42.94 33.3297 43.4466 34.3398 43.7231C35.3499 43.9995 36.4103 44.0382 37.4378 43.8362ZM43.8207 32.9339L43.9083 32.7441L43.7396 32.6665C43.7649 32.7564 43.7919 32.8455 43.8207 32.9339ZM50.3804 35.9555C50.4672 35.9196 50.5538 35.8816 50.6402 35.8414L50.4694 35.7628L50.3804 35.9555ZM43.5406 29.4955C43.4441 30.2168 43.4423 30.9476 43.5353 31.6693L44.2522 31.9992L45.0807 30.2041L43.5406 29.4955ZM46.7641 36.1516C47.5889 36.4314 48.4749 36.4778 49.3244 36.2858L49.7242 35.4199L47.5614 34.4249L46.7641 36.1516ZM44.6535 33.087L44.2547 33.9508C44.6588 34.7219 45.2698 35.3651 46.0193 35.8081L46.8163 34.082L44.6535 33.087ZM50.8129 35.018L51.5288 35.3474C52.1379 34.948 52.6932 34.472 53.1809 33.9311L51.6418 33.2229L50.8129 35.018ZM48.7342 31.885L47.9053 33.6801L50.0681 34.6752L50.897 32.8801L48.7342 31.885Z"
        fill="#4086FA"
      />
      <path
        d="M53.7712 20.0024C52.9752 19.6382 52.1096 19.4517 51.2343 19.4556C47.9736 19.4556 44.498 21.9098 42.6881 25.8295C41.3855 28.6504 41.1712 31.712 42.1 34.2295C42.7557 36.0061 43.9135 37.3184 45.4484 38.0246C49.2655 39.781 54.2371 37.1667 56.5315 32.1977C57.8341 29.3767 58.0483 26.3152 57.1196 23.7977C56.464 22.021 55.3061 20.7086 53.7712 20.0024ZM55.5799 31.7608C54.0295 35.1179 51.0453 37.2179 48.2395 37.2179C47.4809 37.2213 46.7307 37.0595 46.041 36.7438C44.7055 36.1294 43.7003 34.9933 43.1341 33.4587C42.3393 31.3049 42.5235 28.6832 43.6398 26.2659C45.6077 22.004 49.8873 19.7686 53.1786 21.283C54.5141 21.8974 55.5193 23.0333 56.0857 24.568C56.8804 26.7218 56.6961 29.3434 55.5799 31.7607V31.7608Z"
        fill="#4086FA"
      />
      <path
        d="M55.1612 25.6034L54.3327 27.3985L55.7306 28.0417C55.7898 27.2917 55.7425 26.5372 55.5901 25.8006L55.1612 25.6034ZM53.1596 29.9384L55.0874 30.8252C55.3314 30.2021 55.5117 29.5558 55.6255 28.8963L53.9886 28.1433L53.1596 29.9384ZM51.9866 32.4782L53.7234 33.2773C54.1241 32.7463 54.4712 32.177 54.7597 31.5777L52.8155 30.6836L51.9866 32.4782ZM50.3352 26.4626L48.1724 25.4674L47.3435 27.2625L49.5063 28.2576L50.3352 26.4626ZM54.4159 25.2606L52.2531 24.2655L51.4243 26.0606L53.587 27.0556L54.4159 25.2606ZM44.998 32.3423L47.1608 33.3374L47.9896 31.5423L45.8269 30.5472L44.998 32.3423ZM46.2545 27.6642L44.3127 26.7707C44.0433 27.3785 43.8342 28.0113 43.6885 28.66L45.4257 29.4592L46.2545 27.6642ZM53.2431 27.8004L51.0804 26.8054L50.2515 28.6005L52.4142 29.5955L53.2431 27.8004ZM52.4534 21.875C51.9751 21.7086 51.472 21.6242 50.9656 21.6255C50.6048 21.6268 50.2451 21.666 49.8925 21.7422L49.6891 22.1828L51.8518 23.1779L52.4534 21.875ZM52.0703 30.3403L49.9076 29.3452L49.0787 31.1403L51.2415 32.1353L52.0703 30.3403ZM47.4272 25.1246L45.7966 24.3747C45.3669 24.8885 44.9905 25.4445 44.6732 26.0343L46.5984 26.9202L47.4272 25.1246ZM48.6 22.5847L48.1754 22.3895C47.5173 22.7542 46.9133 23.2088 46.3807 23.7403L47.7711 24.3801L48.6 22.5847ZM50.6791 25.7177L51.5079 23.9226L49.3452 22.9276L48.5163 24.7227L50.6791 25.7177Z"
        fill="#4086FA"
      />
    </svg>
  );
};

export const SwiftyPredictionsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" fill="#E4F4FE" />
      <rect x="0.5" y="0.5" width="75" height="75" rx="37.5" stroke="#4086FA" />
      <g clipPath="url(#clip0_247_2784)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.8608 53.8948C37.7356 53.8948 35.6821 53.5148 33.736 52.7631C36.6186 50.7232 38.5033 47.3674 38.5033 43.5798C38.5033 43.5589 38.5025 43.5382 38.5024 43.5173H43.1178L46.3389 49.0855L43.8262 53.4287C42.5532 53.7327 41.2257 53.8948 39.8608 53.8948ZM27.2301 53.8948C21.5312 53.8948 16.8945 49.2675 16.8945 43.5799C16.8945 37.8922 21.5308 33.2646 27.2301 33.2646C32.9294 33.2646 37.5658 37.8922 37.5658 43.5799C37.5658 49.2676 32.9291 53.8948 27.2301 53.8948ZM26.8037 48.7988V50.1998C26.8037 50.4352 26.9943 50.6253 27.2301 50.6253C27.4659 50.6253 27.6566 50.4353 27.6566 50.2V48.7988L27.9984 48.7029C29.221 48.3597 30.0709 47.2412 30.0709 45.973C30.0709 44.4627 29.3876 43.729 27.9932 43.3203L27.6566 43.2217V39.0661L28.3742 39.5151C28.9564 39.8792 29.2181 40.4821 29.2181 41.1541C29.2181 41.3896 29.4086 41.5798 29.6446 41.5798C29.8804 41.5798 30.071 41.3895 30.071 41.1541C30.071 39.8166 29.3068 38.7811 28.0089 38.4491L27.6566 38.359V36.9594C27.6566 36.7239 27.4661 36.5337 27.2301 36.5337C26.9943 36.5337 26.8037 36.724 26.8037 36.9594V38.359L26.4514 38.449C25.1535 38.781 24.3893 39.8167 24.3893 41.1541C24.3893 42.6649 25.0726 43.3983 26.4671 43.8071L26.8037 43.9057V48.1195L26.0583 47.5749C25.5461 47.2008 25.2423 46.608 25.2423 45.973C25.2423 45.7376 25.0516 45.5474 24.8158 45.5474C24.5799 45.5474 24.3893 45.7376 24.3893 45.973C24.3893 47.2412 25.2392 48.3597 26.4619 48.7029L26.8037 48.7988ZM27.6566 48.1193V44.0222L28.3288 44.3457C29.0248 44.6807 29.2181 45.2313 29.2181 45.9731C29.2181 46.6081 28.9144 47.201 28.402 47.5751L27.6566 48.1193ZM26.8037 39.0663V43.1054L26.1314 42.7818C25.4356 42.4468 25.2423 41.896 25.2423 41.1542C25.2423 40.4821 25.5041 39.8791 26.0862 39.5149L26.8037 39.0663ZM23.2662 33.0476C23.9611 30.0533 25.4471 27.3775 27.4802 25.2338H32.0473L32.3459 25.7274L35.4205 30.8085L33.4558 34.2049C31.6708 33.0203 29.5301 32.329 27.2301 32.329C25.8357 32.329 24.4999 32.5836 23.2662 33.0476ZM28.5699 24.1817C30.1551 22.7808 31.9994 21.6718 34.0133 20.9331L32.0473 24.1817H28.5699ZM35.5345 20.4546C36.9207 20.0895 38.3713 19.8948 39.8607 19.8948C41.2249 19.8948 42.5519 20.0566 43.8241 20.3605L46.3391 24.7078L43.1177 30.2762H36.3303L32.9606 24.7078L35.5345 20.4546ZM45.2832 20.7781C47.4727 21.5141 49.4646 22.6829 51.1564 24.1821H47.2525L45.2832 20.7781ZM52.2438 25.2342C54.1867 27.2882 55.6242 29.8233 56.3541 32.6396L54.1952 36.3708L47.2518 36.3707L44.0306 30.8025L47.252 25.2342L52.2438 25.2342ZM56.6772 34.1855C56.8195 35.0682 56.8945 35.9729 56.8945 36.895C56.8945 37.8181 56.8193 38.7239 56.6768 39.6076L55.1086 36.8971L56.6772 34.1855ZM56.3533 41.1534C55.6225 43.9703 54.1843 46.5059 52.24 48.5596L47.2528 48.5597L44.0312 42.9908L47.2521 37.423H54.1951L56.3533 41.1534ZM51.1517 49.6117C49.4614 51.1081 47.4724 52.2755 45.2857 53.0106L47.2522 49.6117H51.1517ZM34.3104 34.8316L36.3373 31.3282H43.1176L46.339 36.8971L43.1178 42.4649L38.4479 42.465C38.1435 39.3901 36.5935 36.6758 34.3104 34.8316Z"
          fill="#4086FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_247_2784">
          <rect
            width="42"
            height="42"
            fill="white"
            transform="translate(17 17)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SwiftyGlobalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <circle cx="28" cy="28" r="28" fill="url(#paint0_linear_363_914)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5677 26.4751C18.2375 28.427 18.5162 30.8208 21.1582 31.2688C23.074 31.5908 26.137 30.8928 30.3491 29.1709C30.5952 29.0709 30.8433 28.9669 31.0976 28.8609C26.6922 32.3327 22.6042 33.9926 18.8355 33.8406C15.3393 33.6946 11.7475 32.2367 12.014 28.203C12.6526 18.5496 29.6128 12.048 38.155 12C35.7144 12.8279 33.3368 13.8259 31.0406 14.9858C32.8202 14.7638 34.6202 14.7438 36.4059 14.9218C33.8656 15.6518 31.4047 16.6257 29.0576 17.8276C30.8332 17.4017 32.6514 17.1637 34.4778 17.1157C29.6739 18.5976 22.474 22.2194 19.5677 26.4751ZM36.4283 29.5229C37.7543 27.571 37.4798 25.1772 34.8378 24.7292C32.8772 24.3972 29.7166 25.1352 25.356 26.9431L25.0469 27.0731L24.9025 27.133L25.0347 27.0311C25.1241 26.9611 25.2157 26.8911 25.3052 26.8231C25.3845 26.7631 25.4638 26.7031 25.539 26.6451C25.6855 26.5311 25.8319 26.4231 25.9784 26.3171C25.9906 26.3091 26.0028 26.2991 26.015 26.2911C29.9972 23.3913 33.7151 22.0134 37.1645 22.1574C40.6607 22.3034 44.2525 23.7613 43.986 27.795C43.3474 37.4484 26.3872 43.95 17.847 44C20.2877 43.1721 22.6652 42.1741 24.9614 41.0142C23.1798 41.2362 21.3778 41.2562 19.59 41.0782C22.1303 40.3462 24.5913 39.3743 26.9383 38.1724C25.1628 38.5983 23.3445 38.8363 21.5181 38.8823C26.3221 37.4004 33.5199 33.7846 36.4283 29.5229Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_363_914"
          x1="-0.232427"
          y1="0.236024"
          x2="54.7754"
          y2="56.1783"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1991" stopColor="#FF3364" />
          <stop offset="0.5104" stopColor="#BB34FF" />
          <stop offset="0.8072" stopColor="#3586FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const SwiftyVerificationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.25 12C22.25 10.57 21.37 9.33 20.06 8.66C20.52 7.27 20.26 5.76 19.25 4.75C18.24 3.74 16.73 3.48 15.34 3.94C14.68 2.63 13.43 1.75 12 1.75C10.57 1.75 9.33 2.63 8.67 3.94C7.27 3.48 5.76 3.74 4.75 4.75C3.74 5.76 3.49 7.27 3.95 8.66C2.64 9.33 1.75 10.57 1.75 12C1.75 13.43 2.64 14.67 3.95 15.34C3.49 16.73 3.74 18.24 4.75 19.25C5.76 20.26 7.27 20.51 8.66 20.06C9.33 21.37 10.57 22.25 12 22.25C13.43 22.25 14.68 21.37 15.34 20.06C16.73 20.51 18.24 20.26 19.25 19.25C20.26 18.24 20.52 16.73 20.06 15.34C21.37 14.67 22.25 13.43 22.25 12ZM10.54 16.2L6.8 12.46L8.21 11.04L10.47 13.3L15.27 8.07L16.74 9.43L10.54 16.2Z"
        fill="#4086FA"
      />
    </svg>
  );
};

export const TwitterIcon = (props) => {
  const { fill = "#464655" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4455 23L10.896 15.0901L3.94886 23H1.00977L9.59209 13.2311L1.00977 1H8.55571L13.786 8.45502L20.3393 1H23.2784L15.0943 10.3165L23.9914 23H16.4455ZM19.7185 20.77H17.7398L5.21811 3.23H7.1971L12.2121 10.2532L13.0793 11.4719L19.7185 20.77Z"
        fill={fill}
      />
    </svg>
  );
};
export const LinkedInIcon = (props) => {
  const { fill = "#464655" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_419_128)">
        <path
          d="M22.7234 0H2.27187C1.29219 0 0.5 0.773438 0.5 1.72969V22.2656C0.5 23.2219 1.29219 24 2.27187 24H22.7234C23.7031 24 24.5 23.2219 24.5 22.2703V1.72969C24.5 0.773438 23.7031 0 22.7234 0ZM7.62031 20.4516H4.05781V8.99531H7.62031V20.4516ZM5.83906 7.43438C4.69531 7.43438 3.77188 6.51094 3.77188 5.37187C3.77188 4.23281 4.69531 3.30937 5.83906 3.30937C6.97813 3.30937 7.90156 4.23281 7.90156 5.37187C7.90156 6.50625 6.97813 7.43438 5.83906 7.43438ZM20.9516 20.4516H17.3937V14.8828C17.3937 13.5562 17.3703 11.8453 15.5422 11.8453C13.6906 11.8453 13.4094 13.2937 13.4094 14.7891V20.4516H9.85625V8.99531H13.2687V10.5609H13.3156C13.7891 9.66094 14.9516 8.70938 16.6813 8.70938C20.2859 8.70938 20.9516 11.0813 20.9516 14.1656V20.4516Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_419_128">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const InstagramIcon = (props) => {
  const { fill = "#464655" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_419_131)">
        <path
          d="M12.5 2.16094C15.7063 2.16094 16.0859 2.175 17.3469 2.23125C18.5188 2.28281 19.1516 2.47969 19.5734 2.64375C20.1313 2.85938 20.5344 3.12188 20.9516 3.53906C21.3734 3.96094 21.6313 4.35938 21.8469 4.91719C22.0109 5.33906 22.2078 5.97656 22.2594 7.14375C22.3156 8.40937 22.3297 8.78906 22.3297 11.9906C22.3297 15.1969 22.3156 15.5766 22.2594 16.8375C22.2078 18.0094 22.0109 18.6422 21.8469 19.0641C21.6313 19.6219 21.3687 20.025 20.9516 20.4422C20.5297 20.8641 20.1313 21.1219 19.5734 21.3375C19.1516 21.5016 18.5141 21.6984 17.3469 21.75C16.0813 21.8062 15.7016 21.8203 12.5 21.8203C9.29375 21.8203 8.91406 21.8062 7.65313 21.75C6.48125 21.6984 5.84844 21.5016 5.42656 21.3375C4.86875 21.1219 4.46563 20.8594 4.04844 20.4422C3.62656 20.0203 3.36875 19.6219 3.15313 19.0641C2.98906 18.6422 2.79219 18.0047 2.74063 16.8375C2.68438 15.5719 2.67031 15.1922 2.67031 11.9906C2.67031 8.78438 2.68438 8.40469 2.74063 7.14375C2.79219 5.97187 2.98906 5.33906 3.15313 4.91719C3.36875 4.35938 3.63125 3.95625 4.04844 3.53906C4.47031 3.11719 4.86875 2.85938 5.42656 2.64375C5.84844 2.47969 6.48594 2.28281 7.65313 2.23125C8.91406 2.175 9.29375 2.16094 12.5 2.16094ZM12.5 0C9.24219 0 8.83438 0.0140625 7.55469 0.0703125C6.27969 0.126563 5.40313 0.332812 4.64375 0.628125C3.85156 0.9375 3.18125 1.34531 2.51563 2.01562C1.84531 2.68125 1.4375 3.35156 1.12813 4.13906C0.832812 4.90313 0.626563 5.775 0.570313 7.05C0.514063 8.33437 0.5 8.74219 0.5 12C0.5 15.2578 0.514063 15.6656 0.570313 16.9453C0.626563 18.2203 0.832812 19.0969 1.12813 19.8563C1.4375 20.6484 1.84531 21.3188 2.51563 21.9844C3.18125 22.65 3.85156 23.0625 4.63906 23.3672C5.40313 23.6625 6.275 23.8687 7.55 23.925C8.82969 23.9812 9.2375 23.9953 12.4953 23.9953C15.7531 23.9953 16.1609 23.9812 17.4406 23.925C18.7156 23.8687 19.5922 23.6625 20.3516 23.3672C21.1391 23.0625 21.8094 22.65 22.475 21.9844C23.1406 21.3188 23.5531 20.6484 23.8578 19.8609C24.1531 19.0969 24.3594 18.225 24.4156 16.95C24.4719 15.6703 24.4859 15.2625 24.4859 12.0047C24.4859 8.74688 24.4719 8.33906 24.4156 7.05938C24.3594 5.78438 24.1531 4.90781 23.8578 4.14844C23.5625 3.35156 23.1547 2.68125 22.4844 2.01562C21.8188 1.35 21.1484 0.9375 20.3609 0.632812C19.5969 0.3375 18.725 0.13125 17.45 0.075C16.1656 0.0140625 15.7578 0 12.5 0Z"
          fill={fill}
        />
        <path
          d="M12.5 5.83594C9.09688 5.83594 6.33594 8.59688 6.33594 12C6.33594 15.4031 9.09688 18.1641 12.5 18.1641C15.9031 18.1641 18.6641 15.4031 18.6641 12C18.6641 8.59688 15.9031 5.83594 12.5 5.83594ZM12.5 15.9984C10.2922 15.9984 8.50156 14.2078 8.50156 12C8.50156 9.79219 10.2922 8.00156 12.5 8.00156C14.7078 8.00156 16.4984 9.79219 16.4984 12C16.4984 14.2078 14.7078 15.9984 12.5 15.9984Z"
          fill={fill}
        />
        <path
          d="M20.3469 5.59214C20.3469 6.38902 19.7 7.0312 18.9078 7.0312C18.1109 7.0312 17.4688 6.38433 17.4688 5.59214C17.4688 4.79526 18.1156 4.15308 18.9078 4.15308C19.7 4.15308 20.3469 4.79995 20.3469 5.59214Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_419_131">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VectorIcon = (props) => {
  const { className, fill = "#EB3492" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
    >
      <path
        d="M2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6C6.708 21.6 2.4 17.292 2.4 12ZM-5.24537e-07 12C-2.34992e-07 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 1.09327e-06 12 1.38281e-06C5.376 1.67236e-06 -8.14081e-07 5.376 -5.24537e-07 12ZM16.0195 11.5996C16.2658 11.8048 16.2581 12.1855 16.0037 12.3805L11.3042 15.9834C10.9753 16.2356 10.5 16.0011 10.5 15.5866L10.5 8.06752C10.5 7.6436 10.9944 7.41202 11.3201 7.68341L16.0195 11.5996Z"
        fill={fill}
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 12.5C13.6569 12.5 15 11.1569 15 9.5C15 7.84315 13.6569 6.5 12 6.5C10.3431 6.5 9 7.84315 9 9.5C9 11.1569 10.3431 12.5 12 12.5Z"
        stroke="#2D87DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C14 18 20 15.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 15.4183 10 18 12 22Z"
        stroke="#2D87DE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlayCircleIcon = (props) => {
  const { className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <path
        d="M34 62.3334C49.6481 62.3334 62.3333 49.6482 62.3333 34.0001C62.3333 18.352 49.6481 5.66675 34 5.66675C18.3519 5.66675 5.66666 18.352 5.66666 34.0001C5.66666 49.6482 18.3519 62.3334 34 62.3334Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9167 25.4019C26.9167 24.0496 26.9167 23.3734 27.1993 22.9959C27.4455 22.667 27.8225 22.4612 28.2324 22.4319C28.7028 22.3983 29.2715 22.7639 30.409 23.4952L43.7841 32.0934C44.7712 32.728 45.2647 33.0453 45.4352 33.4487C45.5841 33.8012 45.5841 34.199 45.4352 34.5515C45.2647 34.9549 44.7712 35.2722 43.7841 35.9068L30.4091 44.505C29.2715 45.2362 28.7028 45.6019 28.2324 45.5683C27.8225 45.539 27.4455 45.3332 27.1993 45.0042C26.9167 44.6268 26.9167 43.9506 26.9167 42.5983V25.4019Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = (props) => {
  const { className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <path
        d="M3 12H15M3 6H21M3 18H21"
        stroke="#464655"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  const { className, onClick, fill = "#fff" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <g opacity="0.7">
        <path d="M18 6L6 18M6 6L18 18" stroke={fill} strokeWidth="2" />
      </g>
    </svg>
  );
};

export const PlayVideoIcon = (props) => {
  const { className, onClick, fill = "#4086FA" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 18.5C14.4705 18.5 18.5 14.4705 18.5 9.5C18.5 4.52943 14.4705 0.5 9.5 0.5C4.52943 0.5 0.5 4.52943 0.5 9.5C0.5 14.4705 4.52943 18.5 9.5 18.5ZM8.32415 12.9612L12.5723 10.4531C13.2759 10.0377 13.2759 8.96234 12.5723 8.5469L8.32415 6.03877C7.64034 5.63505 6.8 6.16052 6.8 6.99184V12.0081C6.8 12.8395 7.64034 13.365 8.32415 12.9612Z"
        fill={fill}
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  const { className, onClick } = props;
  return (
    <svg
      xmlns="
    http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
      onClick={onClick}
      className={className}
    >
      <g filter="url(#filter0_bi_932_870)">
        <circle cx="37" cy="37" r="36" fill="black" fillOpacity="0.3" />
        <circle
          cx="37"
          cy="37"
          r="36.5"
          stroke="url(#paint0_linear_932_870)"
          strokeOpacity="0.4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9988 49.7022L48.9994 38.907C50.3335 38.0598 50.3335 35.9402 48.9994 35.093L31.9988 24.2978C30.6657 23.4512 29 24.5105 29 26.2047V47.7953C29 49.4895 30.6657 50.5488 31.9988 49.7022Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_bi_932_870"
          x="-20"
          y="-20"
          width="114"
          height="114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood fillOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_932_870"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_932_870"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.46045"
            operator="dilate"
            in="SourceAlpha"
            result="effect2_innerShadow_932_870"
          />
          <feOffset dx="-0.730227" dy="0.730227" />
          <feGaussianBlur stdDeviation="0.365113" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_932_870"
          />
        </filter>
        <linearGradient
          id="paint0_linear_932_870"
          x1="64.5806"
          y1="5.93549"
          x2="37"
          y2="73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="173"
      height="138"
      viewBox="0 0 173 138"
      fill="none"
    >
      <rect x="0.5" width="172" height="138" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.844 92.4599H106.452C106.806 92.4599 107.152 92.4216 107.484 92.3488C107.817 92.4216 108.162 92.4599 108.516 92.4599H144.292C146.952 92.4599 149.108 90.2974 149.108 87.6299C149.108 84.9624 146.952 82.7999 144.292 82.7999H140.164C137.504 82.7999 135.348 80.6374 135.348 77.9699C135.348 75.3024 137.504 73.1399 140.164 73.1399H153.236C155.896 73.1399 158.052 70.9774 158.052 68.3099C158.052 65.6424 155.896 63.4799 153.236 63.4799H138.1C140.76 63.4799 142.916 61.3174 142.916 58.6499C142.916 55.9824 140.76 53.8199 138.1 53.8199H94.068C96.7279 53.8199 98.884 51.6574 98.884 48.9899C98.884 46.3224 96.7279 44.1599 94.068 44.1599H54.852C52.1922 44.1599 50.036 46.3224 50.036 48.9899C50.036 51.6574 52.1922 53.8199 54.852 53.8199H27.332C24.6722 53.8199 22.516 55.9824 22.516 58.6499C22.516 61.3174 24.6722 63.4799 27.332 63.4799H44.532C47.1918 63.4799 49.348 65.6424 49.348 68.3099C49.348 70.9774 47.1918 73.1399 44.532 73.1399H17.012C14.3522 73.1399 12.196 75.3024 12.196 77.9699C12.196 80.6374 14.3522 82.7999 17.012 82.7999H43.844C41.1842 82.7999 39.028 84.9624 39.028 87.6299C39.028 90.2974 41.1842 92.4599 43.844 92.4599ZM155.988 92.4599C158.648 92.4599 160.804 90.2974 160.804 87.6299C160.804 84.9624 158.648 82.7999 155.988 82.7999C153.328 82.7999 151.172 84.9624 151.172 87.6299C151.172 90.2974 153.328 92.4599 155.988 92.4599Z"
        fill="#F3F7FF"
      />
      <path
        d="M119.18 31.05V35.19"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.18 40.71V44.85"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M112.3 37.9502H116.428"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M121.932 37.9502H126.06"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.0759 102.12V104.88"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.0759 110.4V113.16"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.572 107.64H59.324"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.8281 107.64H67.5801"
        stroke="#75A4FE"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.07 90.4771C112.026 89.3019 112.886 88.0729 113.649 86.801C115.328 84.0035 116.538 80.9979 117.277 77.8992C118.025 74.7652 118.292 71.536 118.075 68.3303C117.886 65.533 117.33 62.7537 116.404 60.0711C115.486 57.4098 114.204 54.8438 112.558 52.4503C111.577 51.024 110.467 49.6589 109.227 48.3714C107.407 46.481 105.41 44.865 103.289 43.5242C101.009 42.0835 98.5854 40.9606 96.0814 40.1568C92.9456 39.15 89.6838 38.6436 86.4215 38.6399C83.8833 38.6371 81.3447 38.9385 78.865 39.5455C76.0732 40.2288 73.356 41.2994 70.7975 42.7587C68.5485 44.0415 66.4222 45.6248 64.4758 47.5096C62.0298 49.8782 60.0485 52.5483 58.5337 55.4059C57.0506 58.2036 56.0147 61.1809 55.4276 64.2311C54.8227 67.3735 54.6942 70.5932 55.044 73.7731C55.4973 77.8947 56.7539 81.9496 58.818 85.6831C60.1387 88.072 61.7899 90.3294 63.7728 92.3884C66.9207 95.6572 70.5958 98.1059 74.5319 99.7294C79.3187 101.704 84.4915 102.458 89.5717 101.982C93.8355 101.583 98.0341 100.317 101.884 98.1801"
        fill="white"
      />
      <path
        d="M111.07 90.4771C112.026 89.3019 112.886 88.0729 113.649 86.801C115.328 84.0035 116.538 80.9979 117.277 77.8992C118.025 74.7652 118.292 71.536 118.075 68.3303C117.886 65.533 117.33 62.7537 116.404 60.0711C115.486 57.4098 114.204 54.8438 112.558 52.4503C111.577 51.024 110.467 49.6589 109.227 48.3714C107.407 46.481 105.41 44.865 103.289 43.5242C101.009 42.0835 98.5854 40.9606 96.0814 40.1568C92.9456 39.15 89.6838 38.6436 86.4215 38.6399C83.8833 38.6371 81.3447 38.9385 78.865 39.5455C76.0732 40.2288 73.356 41.2994 70.7975 42.7587C68.5485 44.0415 66.4222 45.6248 64.4758 47.5096C62.0298 49.8782 60.0485 52.5483 58.5337 55.4059C57.0506 58.2036 56.0147 61.1809 55.4276 64.2311C54.8227 67.3735 54.6942 70.5932 55.044 73.7731C55.4973 77.8947 56.7539 81.9496 58.818 85.6831C60.1387 88.072 61.7899 90.3294 63.7728 92.3884C66.9207 95.6572 70.5958 98.1059 74.5319 99.7294C79.3187 101.704 84.4915 102.458 89.5717 101.982C93.8355 101.583 98.0341 100.317 101.884 98.1801"
        stroke="#1F64E7"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.183 96.8609C106.182 95.5705 107.96 93.9606 109.116 92.6609L104.183 96.8609Z"
        fill="white"
      />
      <path
        d="M104.183 96.8609C106.182 95.5705 107.96 93.9606 109.116 92.6609"
        stroke="#1F64E7"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M115.396 72.1856C115.199 72.1891 115.002 72.1909 114.804 72.1909C97.4299 72.1909 83.2036 58.6059 82.0114 41.3999C68.1821 43.5876 57.604 55.6502 57.604 70.2029C57.604 86.3059 70.5559 99.3599 86.5329 99.3599C101.849 99.3599 114.385 87.3639 115.396 72.1856Z"
        fill="#E8F0FE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.5081 69.2573C74.6664 68.4778 73.3609 68.5377 72.5921 69.3909C71.8233 70.2442 71.8823 71.5678 72.724 72.3472L82.4378 81.3434C83.6161 82.4346 85.4438 82.3508 86.5202 81.1562C86.5652 81.1055 86.5652 81.1055 86.6086 81.0534L100.471 64.1504C101.2 63.2617 101.08 61.9424 100.204 61.2035C99.327 60.4647 98.0257 60.5861 97.2969 61.4747L84.264 77.3662L75.5081 69.2573Z"
        fill="white"
        stroke="#1F64E7"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.7469 44.4447C75.4052 44.9496 74.0946 45.563 72.8284 46.2854C70.8609 47.4078 69.0007 48.7931 67.2979 50.4423C66.5999 51.1183 65.9452 51.8224 65.3337 52.551M63.4419 55.0879C62.9557 55.8247 62.5082 56.58 62.0996 57.351C61.7977 57.9203 61.5171 58.4982 61.2576 59.0834"
        fill="white"
      />
      <path
        d="M77.1852 45.6167C77.8307 45.3738 78.1576 44.6522 77.9155 44.0049C77.6734 43.3576 76.9539 43.0298 76.3085 43.2727L77.1852 45.6167ZM72.8284 46.2854L73.4455 47.3734L72.8284 46.2854ZM67.2979 50.4423L66.4309 49.5419L67.2979 50.4423ZM64.3788 51.7451C63.9349 52.2741 64.0026 53.0637 64.53 53.5089C65.0574 53.954 65.8448 53.886 66.2887 53.357L64.3788 51.7451ZM64.4827 55.7787C64.8632 55.2021 64.7056 54.4254 64.1307 54.0439C63.5559 53.6624 62.7815 53.8206 62.401 54.3971L64.4827 55.7787ZM62.0996 57.351L63.2017 57.9385L63.2017 57.9385L62.0996 57.351ZM60.1171 58.5749C59.837 59.2067 60.1206 59.9465 60.7505 60.2273C61.3804 60.5082 62.118 60.2237 62.3981 59.592L60.1171 58.5749ZM76.3085 43.2727C74.9057 43.8005 73.5353 44.442 72.2113 45.1973L73.4455 47.3734C74.6538 46.6841 75.9046 46.0986 77.1852 45.6167L76.3085 43.2727ZM72.2113 45.1973C70.1538 46.3711 68.2095 47.8193 66.4309 49.5419L68.1649 51.3427C69.7919 49.767 71.568 48.4445 73.4455 47.3734L72.2113 45.1973ZM66.4309 49.5419C65.7019 50.2479 65.0178 50.9835 64.3788 51.7451L66.2887 53.357C66.8725 52.6613 67.4979 51.9887 68.1649 51.3427L66.4309 49.5419ZM62.401 54.3971C61.8926 55.1675 61.4248 55.9573 60.9975 56.7634L63.2017 57.9385C63.5917 57.2028 64.0187 56.4819 64.4827 55.7787L62.401 54.3971ZM60.9975 56.7634C60.6819 57.3588 60.3884 57.963 60.1171 58.5749L62.3981 59.592C62.6458 59.0334 62.9136 58.4819 63.2017 57.9385L60.9975 56.7634Z"
        fill="#75A4FE"
      />
    </svg>
  );
};
